module.exports = __webpack_public_path__ + "static/media/Maintenance-Required.5ce69637.png";